export const filterContactFields = (fields: string[]) => 
  fields.filter(f => f !== 'Phone' && f !== 'Email')
